import { lazy, Suspense, ComponentType } from "react";

import Loading from "#components/Loading";
import ErrorBoundary from "#components/ErrorBoundary/ErrorBoundary";

export function lazyWithSuspense<P extends object>(
  importFn: () => Promise<{ default: ComponentType<P> }>,
  fallback?: React.ReactNode
): ComponentType<P> {
  const LazyComponent = lazy(importFn);

  const ComponentWithSuspense: ComponentType<P> = (props: P) => (
    <ErrorBoundary>
      <Suspense fallback={fallback || <Loading text="Loading Page" pending />}>
        <LazyComponent {...props} />
      </Suspense>
    </ErrorBoundary>
  );

  return ComponentWithSuspense;
}
